import React, { useEffect, useState } from 'react'
import db from '../../resources/db'
import jsonata from 'jsonata'
import PlaceofSupply from '../../resources/PlaceofSupply';

import { exportReport } from '../../resources/Excel';
import MaterialTable from 'material-table';
import tableIcons from '../../resources/tableIcons';
import moment from 'moment';
import { dataIsBetweenDates } from './Sales';
import { useIonLoading } from '@ionic/react';


const Purchase = ({ to, from }) => {

    const [Report, setReport] = useState({
        header: [],
        data: [],
    });
    const [List, setList] = useState(Report.data);
    const [columns, setColumns] = useState([]);
    const [presentLoading, dismissLoading] = useIonLoading();


    useEffect(() => {
        presentLoading({ message: 'Please wait...' });
        db.getPurchases().then(purchase => {
            // setInvoices(gstInvoice);
            console.log(purchase[0]);
            const report = convertToGST_Purchase_Report(purchase, from, to);
            console.log(report);
            setReport(report);
            setList(report.data);

            const columns = report.header.map((header, i) => {
                let row = { title: header, field: report.keys[i]};
                if (i === 4) {
                    row.type = 'date';
                } else if (i > 5) {
                    row.type = 'currency'
                    row.currencySetting = { currencyCode: 'INR' }
                }
                return row;
            });
            setColumns(columns);
            dismissLoading();
        })
        return () => {
            setColumns([]);
            setList([]);
            setReport({ header: [], data: [] });
        }
    }, [from, to]);

    return (
        <div>
            <MaterialTable columns={columns} icons={tableIcons}
                options={{
                    headerStyle: {
                        backgroundColor: '#01579b',
                        color: '#FFF'
                    },
                    grouping: true,
                    exportButton: true,
                    pageSize: 10,
                    columnResizable: true,
                    exportFileName: 'GST_Purchase_Report',
                    columnsButton: true,
                    padding: 'dense',
                }}
                actions={
                    [
                        {
                            icon: tableIcons.Excel,
                            tooltip: 'Export All Data to Excel',
                            isFreeAction: true,
                            onClick: () => {
                                exportReport(from, to);
                            }
                        },

                    ]
                }
                data={List} title="GST Purchase Report" />

        </div>
    )
}

export default Purchase

/**
 * Convert Invoices to GST Sales Report between given dates
 * @param {Array} arr 
 * @param {Date} from 
 * @param {Date} to 
 * @returns 
 */
export function convertToGST_Purchase_Report(arr, from = moment().subtract(1, 'months').toDate(), to = moment().toDate(), excel = false) {
    const array = dataIsBetweenDates(arr, from, to);
    const keys = ['partyGST', 'partyName', 'pos', 'invoiceNo', 'billDate', 'gstRate', 'igst', 'cgst', 'sgst', 'amt', 'gstAmt', 'total'];
    const header = ['GSTIN', 'Party Name', 'Place of Supply', 'Invoice No', 'Invoice Date', 'Rate of Tax %', 'IGST', 'CGST', 'SGST', 'Invoice Value', 'Tax Value', 'Gross Value'];
    let list = [];
    let gstInvoices = array.length ? jsonata(`$[gstEnabled = true]`).evaluate(array) : [];
    gstInvoices = Array.isArray(gstInvoices) ? gstInvoices : gstInvoices ? [].concat(gstInvoices) : [];
    // console.log(gstInvoices);
    const gstRate = [5, 12, 18, 28];

    gstInvoices.forEach((invoice, j) => {
        gstRate.forEach((rate, i) => {
            const gstRate = rate;
            const amt = jsonata(`$sum(products[gstr = ${rate}].amount)`).evaluate(invoice);
            const gstAmt = jsonata(`$sum(products[gstr = ${rate}].gstAmt)`).evaluate(invoice);
            const total = jsonata(`$sum(products[gstr = ${rate}].total)`).evaluate(invoice);
            const posCode = invoice.partyGST.substring(0, 2);
            const myposCode = invoice.gst.substring(0, 2);
            const posState = PlaceofSupply[parseInt(posCode)];
            const pos = `${posCode} - ${posState}`;

            let igst = '', cgst = '', sgst = '';
            if (posCode === myposCode) {
                sgst = gstAmt / 2;
                cgst = gstAmt / 2;
                igst = 0;
            } else {
                igst = gstAmt;
                cgst = 0;
                sgst = 0;
            }

            const invoiceInfoPerGSTRate = {
                partyGST: invoice.partyGST,
                partyName: invoice.partyName,
                pos,
                invoiceNo: invoice.billNo,
                billDate: excel ? moment(invoice.billDate).calendar() : moment(invoice.billDate).toDate(),
                gstRate,
                igst: Number(parseFloat(igst).toFixed(2)),
                cgst: Number(parseFloat(cgst).toFixed(2)),
                sgst: Number(parseFloat(sgst).toFixed(2)),
                amt: Number(parseFloat(amt).toFixed(2)),
                gstAmt: Number(parseFloat(gstAmt).toFixed(2)),
                total: Number(parseFloat(total).toFixed(2)),
                totalAmt: Number(parseFloat(invoice.totalAmt).toFixed(2)),
                id: i + j + invoice.id,
            }
            amt && list.push(invoiceInfoPerGSTRate);
        });
    });

    const totals = {
        partyGST: '',
        partyName: '',
        pos: '',
        invoiceNo: '',
        billDate: '',
        gstRate: 'TOTAL',
        igst: jsonata(`$sum(igst)`).evaluate(list) || 0,
        cgst: jsonata(`$sum(cgst)`).evaluate(list) || 0,
        sgst: jsonata(`$sum(sgst)`).evaluate(list) || 0,
        amt: jsonata(`$sum(amt)`).evaluate(list) || 0,
        gstAmt: jsonata(`$sum(gstAmt)`).evaluate(list) || 0,
        total: jsonata(`$sum(total)`).evaluate(list) || 0,
        totalAmt: jsonata(`$sum(totalAmt)`).evaluate(list) || 0,
        id: '',
    }

    const gstTotal = gstRate.map(rate => ({
        partyGST: '',
        partyName: '',
        pos: '',
        invoiceNo: '',
        billDate: '',
        gstRate: `@${rate}%`,
        igst: jsonata(`$sum($[gstRate = ${rate}].igst)`).evaluate(list),
        cgst: jsonata(`$sum($[gstRate = ${rate}].cgst)`).evaluate(list),
        sgst: jsonata(`$sum($[gstRate = ${rate}].sgst)`).evaluate(list),
        amt: jsonata(`$sum($[gstRate = ${rate}].amt)`).evaluate(list),
        gstAmt: jsonata(`$sum($[gstRate = ${rate}].gstAmt)`).evaluate(list),
        total: jsonata(`$sum($[gstRate = ${rate}].total)`).evaluate(list),
        totalAmt: jsonata(`$sum($[gstRate = ${rate}].totalAmt)`).evaluate(list),
        id: '',
    }));

    return { header, keys, data: list, totals, gstTotal };
}
